<template>
	<div class="page">
		<div class="header">
			<h1>Details over je auto</h1>
			<p>Vul hier alles in over je auto wat je er van weet.</p>
		</div>

		<h2>Algemeen</h2>
		<table class="form">
			<tr>
				<td width="18%"><label for="brand">Merk</label></td>
				<td><input type="text" id="brand"></td>
				<td width="18%"><label for="model">Model</label></td>
				<td><input type="text" id="model"></td>
			</tr>
			<tr>
				<td><label for="color">Kleur</label></td>
				<td><input type="text" id="color"></td>
				<td><label for="doors">Aantal deuren</label></td>
				<td><select id="doors">
					<option value="2">2</option>
					<option value="3">3</option>
					<option value="4">4</option>
					<option value="5">5</option>
				</select></td>
			</tr>
			<tr>
				<td><label for="year">Bouwjaar</label></td>
				<td><input type="number" id="year"></td>
				<td><label for="horsepower">Vermogen (PK)</label></td>
				<td><input type="number" id="horsepower"></td>
			</tr>
		</table>

		<h2>Omschrijving</h2>
		<table class="form">
			<tr>
				<td><textarea id="description" placeholder="Schrijf hier een omschrijving over je auto"></textarea></td>
			</tr>
		</table>

		<button type="submit">Opslaan</button>
		<button>Annuleren</button>
	</div>
</template>
<script>
export default {
	name: "Cars",
	title: "Auto details",
	icon: "fas fa-car"
}
</script>